module.exports = __webpack_public_path__ + "prize-6.a2d5a721.png";